<template>
    <v-container class="ma-0 pa-0">
        <v-row class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-0" align-self="start" align="left">
                <p class="diet-title"><span class="number">{{index}}</span> | {{getTitle}}</p>
            </v-col>
        </v-row>

        <v-row class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-0" align-self="start" align="left">
                <p class="desc" v-html="getDescription" />
            </v-col>
        </v-row>

        <v-row class="mx-0 my-5 pa-0">
            <v-col cols="12" class="ma-0 pa-0" align-self="start" align="center">
                <img
                    :src="iconPath"
                    :alt="`${status} 이미지`"
                    class="diet-img"
                />
            </v-col>
        </v-row>

        <div v-if="index !== 6" class="seperator"></div>

    </v-container>
</template>
<script>
    export default {
        data() {
            return {
            }
        },
        props: {
            index: {
                type: Number,
                required: true
            },
            status: {
                type: String,
                required: true
            }
        },
        computed: {
            warning() {
                if(this.disease.status === '주의')
                    return 'warning'
                return ''
            },
            iconPath() {
                if(this.status === 'low') // 대사증후군 예방 가이드
                {
                    switch(this.index) {
                        case 1: return require('@/assets/images/img-eat-01.png')
                        case 2: return require('@/assets/images/img-eat-02.png')
                        case 3: return require('@/assets/images/img-eat-03.png')
                        case 4: return require('@/assets/images/img-eat-04.png')
                        case 5: return require('@/assets/images/img-eat-05.png')
                        case 6: return require('@/assets/images/img-eat-06.png')
                    }
                }
                else // 암 예방 가이드
                {
                    switch(this.index) {
                        case 1: return require('@/assets/images/img-eat-07.png')
                        case 2: return require('@/assets/images/img-eat-08.png')
                        case 3: return require('@/assets/images/img-eat-09.png')
                        case 4: return require('@/assets/images/img-eat-10.png')
                        case 5: return require('@/assets/images/img-eat-11.png')
                    }
                }
            },
            getTitle() {
                let index = this.index - 1
                if(this.status === 'low') {
                    return this.$t(`dietGuide.low.guideList[` + index + `].title`)
                }
                else {
                    return this.$t(`dietGuide.high.guideList[` + index + `].title`)
                }
            },
            getDescription() {
                let index = this.index - 1
                if(this.status === 'low') {
                    return this.$t(`dietGuide.low.guideList[` + index + `].desc`)
                }
                else {
                    return this.$t(`dietGuide.high.guideList[` + index + `].desc`)
                }
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
<style scoped>
    .diet-card {
        text-align: center;
    }
    .number {
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        font-size: 18px;
        letter-spacing: -0.86px;
        color: #7a46c7;
    }
    .diet-title {
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        font-size: 18px;
        letter-spacing: -0.86px;
        color: #193263;
    }
    .desc {
        font-family: "NanumSquare";
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.6px;
        color: #475b82;
    }
    .diet-img {
        width: 100%;
    }
    .seperator {
        height: 1px;
        width: 100%;
        background-color: #e2e6ea;
        margin-bottom: 40px;
    }
</style>
